import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import { pdfDownload } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import { resolveExportBlob } from "helpers/exportDownloadHelper"
import { showAlert } from "store/reducers/alertReducer"
import isPermissionEnabled from "common/isPermissionEnabled"
import { isTenantOwnerAdmin } from "utils/isTenantOwnerAdmin"

export const canExportOrders = ({
  userRole,
  accountType,
}) => {
  if (isTenantOwnerAdmin()) {
    return true
  }

  return (
    isPermissionEnabled(userRole, 9, "order_4", accountType) ||
    isPermissionEnabled(userRole, 9, "export_orders", accountType)
  )
}

export const buildOrderExportPayload = ({
  exportType,
  selectedFilters = {},
  searchTerm = "",
  searchTerm2 = "",
  dateRange = {},
  estimatedDeliveryDateRange = {},
  serviceProvider,
  includeServiceProvider,
  includePosColumns,
  includeSalasaColumns,
  brandId,
  orderIds = [],
  resolveListStatus,
}) => {
  const { status, branchId, orderType, platform, assignmentStatus } =
    selectedFilters
  const branchIds = branchId?.map(item => item.value)
  const updatedOrderType = orderType?.map(item => item.value) || []
  const updatedPlatform =
    platform?.flatMap(item => {
      if (item.value === "android") return [item.value, "Android"]
      if (item.value === "website") return [item.value, "Website"]
      return item.value
    }) || []

  const hasDateRange = dateRange?.min && dateRange?.max
  const hasSelectedOrders = Array.isArray(orderIds) && orderIds.length > 0

  const payload = {
    status: resolveListStatus ? resolveListStatus(status) : Number(status),
    keyword: searchTerm || "",
    orderNo: searchTerm2 || "",
    type: "ORDER",
    exportType,
    branchId: branchIds || [],
    userId: "",
    orderType: updatedOrderType,
    assignmentStatus: assignmentStatus || "",
    platform: updatedPlatform,
    serviceProvider,
    includeServiceProvider:
      typeof includeServiceProvider === "boolean"
        ? includeServiceProvider
        : Boolean(serviceProvider),
    includePosColumns: Boolean(includePosColumns),
    includeSalasaColumns: Boolean(includeSalasaColumns),
    brandId,
    dateRange: hasSelectedOrders
      ? {}
      : hasDateRange
        ? { min: dateRange.min, max: dateRange.max }
        : {},
    estimatedDeliveryDateRange:
      hasSelectedOrders ||
      !(estimatedDeliveryDateRange.min && estimatedDeliveryDateRange.max)
        ? {}
        : {
            min: estimatedDeliveryDateRange.min,
            max: estimatedDeliveryDateRange.max,
          },
  }

  if (hasSelectedOrders) {
    payload.orderIds = orderIds
  }

  return payload
}

export const downloadOrderExport = async ({
  dispatch,
  t,
  payload,
  fileName,
}) => {
  const response = await pdfDownload(EXPORT_DATA, payload)
  const expectXlsx = payload.exportType === "xlsx"
  const resolved = await resolveExportBlob(response, { expectXlsx })

  if (!resolved.ok) {
    dispatch(
      showAlert({
        text: resolved.message || t("Export failed"),
        type: "error",
      })
    )
    return false
  }

  if (payload.exportType === "xlsx") {
    DownloadXLSX(resolved.data, fileName)
  } else {
    DownloadCSV(resolved.data, fileName)
  }

  return true
}

export const buildSingleOrderExportPayload = ({
  orderId,
  exportType,
  serviceProvider,
  includeServiceProvider,
  includePosColumns,
  includeSalasaColumns,
  brandId,
}) => ({
  type: "ORDER",
  exportType,
  orderIds: [orderId],
  serviceProvider,
  includeServiceProvider:
    typeof includeServiceProvider === "boolean"
      ? includeServiceProvider
      : Boolean(serviceProvider),
  includePosColumns: Boolean(includePosColumns),
  includeSalasaColumns: Boolean(includeSalasaColumns),
  brandId,
  status: 0,
  keyword: "",
  orderNo: "",
  branchId: [],
  userId: "",
  orderType: [],
  platform: [],
  dateRange: {},
})
